import { render, staticRenderFns } from "./index.vue?vue&type=template&id=12291266"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12291266')) {
      api.createRecord('12291266', component.options)
    } else {
      api.reload('12291266', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=12291266", function () {
      api.rerender('12291266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/storeReply/index.vue"
export default component.exports